import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "stats" }
const _hoisted_2 = ["^style"]
const _hoisted_3 = { class: "stat-name" }

import { QuizQuestion, UserAnswerStats } from '@/models/quiz-question.model';
import { ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionStats',
  props: {
  question: {
    type: Object as PropType<QuizQuestion>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();

const stats = computed<UserAnswerStats>(() => store.state.cns.questionStats);

onMounted(() => {
  store.dispatch(ContentStoreActions.GetQuizQuestionStats, props.question.id);
});

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Stats", -1)),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.answers, (answer) => {
          return (_openBlock(), _createElementBlock("li", {
            key: answer.id,
            class: "stat-row"
          }, [
            _createElementVNode("div", {
              class: "stat-score",
              "^style": `width: ${
            stats.value.answerStats.find((s) => s.id === answer.id)?.percentage
          }%`
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, _toDisplayString(answer.text), 1),
            _createElementVNode("span", null, "(" + _toDisplayString(stats.value.answerStats.find((s) => s.id === answer.id)?.answers) + " answer" + _toDisplayString(stats.value.answerStats.find((s) => s.id === answer.id)?.answers === 1
              ? ''
              : 's') + " ) " + _toDisplayString(stats.value.answerStats.find((s) => s.id === answer.id)?.percentage) + "%", 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})